import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import API from "../../utils/api";

const initialState = {
  //   token: Cookies.get(TOKEN_COOKIE) || null,
  allCompany: null,

  loading: false,
  company: null,
  error: null,
  editError: null,
  createError: null,
  companyData: null,
  success: null,
  creationStatus: "idle",
};

export const createCompany = createAsyncThunk(
  "company/createCompany",
  async (args, { rejectWithValue }) => {
    // console.log("create", args);
    try {
      const { data } = await API.company.createCompany(args);
      data.data.creationStatus = 'success';
      return data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateCompanyData = createAsyncThunk(
  "company/updateUserData",
  async ({ updatedCompany, id }, { rejectWithValue }) => {
    // console.log("update", updatedCompany, id);
    try {
      const { data } = await API.company.updateCompany(updatedCompany, id);
      // console.log("data checking", data);
      return data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getAllCompanies = createAsyncThunk(
  "company/getAllCompanies",
  async (args, { rejectWithValue }) => {
    try {
      const { data } = await API.company.getAllCompanies();
      return data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addField = createAsyncThunk(
  "company/addField",
  async (formData, { rejectWithValue }) => {
    // console.log(" data is comming or not");

    try {
      const response = await API.company.createForm(formData);
      // dispatch(setForm(response.data));
      return response.data.data;
    } catch (error) {
      // console.log("errorrr", error);
      rejectWithValue(error);
    }
  }
);

export const getCompanyById = createAsyncThunk(
  "company/getCompanyById",
  async (args, { rejectWithValue }) => {
    console.log("iddd", args);
    try {
      const { data } = await API.company.getCompanyById(args);
      // console.log("tttttttttttttttt", data);
      return data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const uploadSubmissionFile = createAsyncThunk(
  "company/uploadSubmissionFile",
  async ({ companyId, employeeId, file }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("datafile", file);
      const {data} = await API.company.postSubmissionFile(companyId, employeeId, formData);
      return data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const companySlice = createSlice({
  name: "company",
  initialState,
  reducers: {
    // clearError: (state) => {
    //   state.error = null;
    // },
    resetResponseState: (state) => {
      state.createError = null;
      state.success = null;
    },
    resetCreationStatus: (state) => {
      state.creationStatus = "idle";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllCompanies.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllCompanies.fulfilled, (state, action) => {
        state.allCompany = action.payload;
        state.error = null;
        state.loading = false;
        // Cookies.set(TOKEN_COOKIE, action.payload);
      })
      .addCase(getAllCompanies.rejected, (state, action) => {
        state.error = action.payload.response;
        state.loading = false;
      })
      .addCase(createCompany.pending, (state) => {
        state.loading = true;
      })
      .addCase(createCompany.fulfilled, (state, action) => {
        state.company = action.payload;
        state.creationStatus = "success";
        state.success = true;
        state.loading = false;
      })
      .addCase(createCompany.rejected, (state, action) => {
        state.createError = action.payload.response.data.message;
        state.creationStatus = "idle";

        state.loading = false;
      })

      .addCase(getCompanyById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCompanyById.fulfilled, (state, action) => {
        state.company = action.payload;
        state.loading = false;
      })
      .addCase(getCompanyById.rejected, (state, action) => {
        state.error = action.payload.response;
        state.loading = false;
      })

      .addCase(updateCompanyData.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateCompanyData.fulfilled, (state, action) => {
        state.companyData = action.payload;
        // console.log(state.userData, "USer data checking");
        state.loading = false;
      })
      .addCase(updateCompanyData.rejected, (state, action) => {
        state.editError = action.payload.response.data;
        // console.log(
        //   action.payload.response.data,
        //   "checking the of the form error"
        // );
        state.loading = false;
      })
      .addCase(addField.pending, (state) => {
        state.loading = true;
      })
      .addCase(addField.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(addField.rejected, (state, action) => {
        state.error = action.payload.response;
        state.loading = false;
      });
  },
});

// console.log(first)
export const selectAllCompanies = (state) => state.company.allCompany;
export const selectCompany = (state) => state.company.company;
export const selectCreationStatus = (state) => state.company.creationStatus;
export const selectError = (state) => state.company.error;

export const selectLoading = (state) => state.company.loading;
// export const selectUse = (state) => state.company.companyData;
export const selectEditError = (state) => state.company.editError;
export const selectCreateError = (state) => state.company.createError;
export const selectStatus = (state) => state.company.success;

export const { resetResponseState, resetCreationStatus } = companySlice.actions;
export default companySlice.reducer;
